export const heroData = {
  tagline: '海量漫画 · 免费畅读',
  title: '番茄漫画 - 免费漫画全集大全',
  subtitle: '追更不停歇，好漫画一网打尽',
  description: '番茄漫画汇聚全网热门韩漫、日漫、国漫资源，涵盖恋爱、热血、悬疑、奇幻、都市等全品类题材。每日同步更新最新话，高清画质流畅阅读体验，支持离线下载随时随地想看就看。无论你是追更党还是补番党，这里都是你的漫画宝藏库。',
  stats: [
    { label: '收录漫画', value: '50,000+' },
    { label: '每日更新', value: '300+话' },
    { label: '活跃读者', value: '800万+' },
  ],
  primaryCta: { label: '立即探索', href: '#index' },
  secondaryCta: { label: '下载APP', href: '#app' },
};

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20girl%20with%20pink%20hair%20and%20big%20sparkling%20eyes%2C%20manga%20art%20style%2C%20clean%20simple%20background%2C%20soft%20pastel%20colors%2C%20kawaii%20aesthetic&width=80&height=80&seq=avatar-comic-01&orientation=squarish',
    name: '星辰大海',
    date: '2小时前',
    manga: '《绝世武魂》',
    content: '这周的更新太炸裂了！主角终于突破了瓶颈期，那段打斗分镜简直可以封神。番茄漫画的清晰度真的没话说，追了一年多了体验一直很稳。',
    likes: 1283,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20boy%20avatar%20with%20silver%20hair%20and%20sharp%20blue%20eyes%2C%20stylish%20manga%20portrait%2C%20minimal%20background%2C%20modern%20anime%20art%20style%2C%20clean%20lineart&width=80&height=80&seq=avatar-comic-02&orientation=squarish',
    name: '夜雨声烦',
    date: '5小时前',
    manga: '《剑道独尊》',
    content: '国漫这几年的进步真的肉眼可见，从画风到剧情都在不断提升。番茄上面的国漫资源是最全的，而且更新速度比别的平台快，这一点必须点赞。',
    likes: 967,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20girl%20avatar%20with%20long%20black%20hair%20and%20gentle%20smile%2C%20watercolor%20style%20manga%20portrait%2C%20soft%20warm%20lighting%2C%20elegant%20kawaii%20aesthetic&width=80&height=80&seq=avatar-comic-03&orientation=squarish',
    name: '樱花飘落',
    date: '1天前',
    manga: '《偷偷藏不住》',
    content: '被闺蜜安利过来的，结果自己彻底沦陷了哈哈。韩漫的恋爱题材真的太上头了，画风细腻故事也走心，离线下载功能通勤路上追漫太方便了。',
    likes: 2156,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Charming%20anime%20character%20avatar%20with%20red%20hair%20and%20mischievous%20expression%2C%20vibrant%20manga%20style%20portrait%2C%20bright%20energetic%20colors%2C%20dynamic%20pose%2C%20clean%20background&width=80&height=80&seq=avatar-comic-04&orientation=squarish',
    name: '追漫小能手',
    date: '2天前',
    manga: '《全职高手》',
    content: '从初中开始看漫画到现在工作，番茄漫画是我用过最舒服的阅读器。没有广告弹窗干扰，翻页流畅度极高，日漫的高清资源也很全。强烈推荐给所有漫友！',
    likes: 3402,
  },
];

export const mediaData = [
  {
    id: 1,
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20manga%20cover%20art%20featuring%20a%20powerful%20martial%20artist%20in%20flowing%20robes%20surrounded%20by%20golden%20energy%2C%20epic%20fantasy%20style%2C%20dramatic%20lighting%2C%20rich%20warm%20colors%2C%20detailed%20background%20with%20ancient%20temples&width=600&height=800&seq=manga-media-01&orientation=portrait',
    title: '绝世武魂',
    tags: ['热血', '玄幻'],
    status: '连载中',
    updateInfo: '更新至 1287 话',
    rating: 9.6,
  },
  {
    id: 2,
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20art%20with%20a%20beautiful%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20color%20palette%2C%20emotional%20atmosphere%2C%20delicate%20lineart%2C%20shojo%20manga%20style&width=600&height=800&seq=manga-media-02&orientation=portrait',
    title: '偷偷藏不住',
    tags: ['恋爱', '校园'],
    status: '连载中',
    updateInfo: '更新至 356 话',
    rating: 9.4,
  },
  {
    id: 3,
    cover: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20with%20a%20mysterious%20hunter%20holding%20a%20glowing%20sword%20in%20a%20shadowy%20dungeon%2C%20dramatic%20contrast%20lighting%2C%20detailed%20armor%20design%2C%20atmospheric%20and%20intense&width=600&height=800&seq=manga-media-03&orientation=portrait',
    title: '全职猎人',
    tags: ['冒险', '热血'],
    status: '连载中',
    updateInfo: '更新至 401 话',
    rating: 9.8,
  },
  {
    id: 4,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20featuring%20a%20stylish%20female%20lead%20in%20modern%20fashion%2C%20urban%20cityscape%20background%2C%20trendy%20vibrant%20colors%2C%20romance%20drama%20vibe%2C%20clean%20digital%20art&width=600&height=800&seq=manga-media-04&orientation=portrait',
    title: '女神降临',
    tags: ['恋爱', '韩漫'],
    status: '已完结',
    updateInfo: '共 267 话（完结）',
    rating: 9.3,
  },
  {
    id: 5,
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20cover%20with%20a%20legendary%20swordsman%20on%20a%20mountain%20peak%20under%20moonlight%2C%20traditional%20Chinese%20art%20influenced%20style%2C%20ink%20wash%20effect%2C%20majestic%20and%20heroic&width=600&height=800&seq=manga-media-05&orientation=portrait',
    title: '剑来',
    tags: ['仙侠', '国漫'],
    status: '连载中',
    updateInfo: '更新至 893 话',
    rating: 9.7,
  },
];

export const aboutData = {
  title: '关于番茄漫画',
  content: '番茄漫画成立于2019年，是国内领先的免费漫画在线阅读平台。我们致力于为广大漫迷打造一个内容全面、体验流畅、完全免费的漫画阅读空间。平台涵盖韩漫、日漫、国漫三大品类，收录超过五万部漫画作品，涵盖恋爱、热血、悬疑、奇幻、都市、仙侠、校园等数十个题材分类。每日同步更新三百余话最新内容，确保读者第一时间追更心仪作品。我们坚持高清画质与极速加载，同时提供离线下载、智能书签、阅读进度云同步等贴心功能。番茄漫画，让每一个热爱漫画的灵魂都能找到属于自己的精彩世界。',
};

export const faqData = [
  {
    q: '番茄漫画真的是完全免费的吗？',
    a: '是的！番茄漫画承诺所有漫画内容永久免费阅读。我们通过广告合作和品牌赞助维持平台运营，不会向读者收取任何费用。您可以放心畅读平台上的每一部漫画。',
  },
  {
    q: '离线下载功能如何使用？',
    a: '在任意漫画详情页点击"下载"按钮即可将漫画章节缓存到本地。下载后的漫画可在无网络环境下正常阅读，下载内容保存在APP本地存储中。建议在Wi-Fi环境下批量下载以节省流量。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '番茄漫画每日同步更新三百余话最新内容。热门连载漫画通常在作者发布后2小时内完成同步上架，确保您第一时间追更心仪作品。您可以在"最近更新"模块查看当日全部更新内容。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '番茄漫画支持网页端（PC/Mac）、iOS客户端和Android客户端。阅读进度通过云端自动同步，您可以在不同设备间无缝切换阅读。APP端还提供专属的夜间模式和横屏阅读优化。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的分类索引按题材浏览，也可以使用搜索功能直接查找漫画名称或作者。热门话题和排行榜模块也能帮助您发现当下最受欢迎的漫画作品。',
  },
  {
    q: '漫画加载慢或显示异常怎么办？',
    a: '首先请检查网络连接状态。如果网络正常，可以尝试清除浏览器缓存或APP缓存后重新加载。若问题仍然存在，欢迎通过"联系我们"模块反馈，我们的技术团队会尽快处理。',
  },
];

export const indexData = [
  { id: 1, name: '热血冒险', icon: 'ri-fire-line', count: '8,200+部', color: 'text-secondary-500' },
  { id: 2, name: '恋爱校园', icon: 'ri-heart-line', count: '6,500+部', color: 'text-secondary-400' },
  { id: 3, name: '玄幻仙侠', icon: 'ri-moon-line', count: '7,800+部', color: 'text-primary-500' },
  { id: 4, name: '悬疑推理', icon: 'ri-search-eye-line', count: '3,200+部', color: 'text-accent-600' },
  { id: 5, name: '都市生活', icon: 'ri-building-line', count: '4,600+部', color: 'text-foreground-600' },
  { id: 6, name: '奇幻异能', icon: 'ri-magic-line', count: '5,100+部', color: 'text-primary-400' },
  { id: 7, name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '3,800+部', color: 'text-accent-500' },
  { id: 8, name: '古风历史', icon: 'ri-ancient-gate-line', count: '2,900+部', color: 'text-secondary-600' },
  { id: 9, name: '科幻未来', icon: 'ri-rocket-line', count: '2,400+部', color: 'text-accent-700' },
];

export const topicsData = [
  { id: 1, name: '绝世武魂', tag: '今日最热', hot: '98.6万', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '剑来', tag: '口碑推荐', hot: '87.3万', color: 'bg-accent-100 text-accent-800' },
  { id: 3, name: '全职猎人', tag: '经典回归', hot: '76.5万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 4, name: '斗破苍穹', tag: '常年霸榜', hot: '152万', color: 'bg-primary-100 text-primary-700' },
  { id: 5, name: '女神降临', tag: '完结必看', hot: '65.8万', color: 'bg-accent-100 text-accent-800' },
  { id: 6, name: '咒术回战', tag: '日漫顶流', hot: '123万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 7, name: '偷偷藏不住', tag: '甜到蛀牙', hot: '71.2万', color: 'bg-primary-100/70 text-primary-700' },
  { id: 8, name: '镖人', tag: '国漫之光', hot: '58.9万', color: 'bg-accent-100/70 text-accent-800' },
  { id: 9, name: '鬼灭之刃', tag: '现象级IP', hot: '186万', color: 'bg-secondary-100/70 text-secondary-800' },
  { id: 10, name: '一人之下', tag: '道系神作', hot: '82.4万', color: 'bg-primary-100 text-primary-700' },
  { id: 11, name: '我独自升级', tag: '韩漫巅峰', hot: '94.1万', color: 'bg-accent-100 text-accent-800' },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20manga%20scene%20with%20a%20warrior%20battling%20a%20massive%20dragon%20in%20a%20stormy%20sky%2C%20dramatic%20dynamic%20composition%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20cinematic%20lighting%2C%20high%20action%20intensity&width=800&height=500&seq=card-manga-01&orientation=landscape',
    title: '热血漫画TOP50：那些燃到让你半夜爬起来画分镜的神作',
    desc: '从经典老番到新晋黑马，这份热血漫榜单承包了你一整年的肾上腺素。',
    tag: '编辑精选',
    date: '7月25日',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20with%20two%20characters%20sharing%20an%20umbrella%20on%20a%20rainy%20street%2C%20warm%20street%20lights%20reflection%2C%20soft%20emotional%20atmosphere%2C%20pastel%20color%20tones%2C%20shojo%20aesthetic&width=800&height=500&seq=card-manga-02&orientation=landscape',
    title: '甜到犯规！这10部恋爱漫画让你秒变柠檬精',
    desc: '每一页都是心动暴击，恋爱漫画的正确打开方式就在番茄漫画。',
    tag: '恋爱专题',
    date: '7月24日',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20manga%20scene%20in%20a%20dimly%20lit%20Victorian%20room%20with%20clues%20scattered%20on%20a%20desk%2C%20atmospheric%20noir%20lighting%2C%20warm%20sepia%20tones%2C%20suspenseful%20mood&width=800&height=500&seq=card-manga-03&orientation=landscape',
    title: '烧脑悬疑漫画推荐：每一部都能让你怀疑人生',
    desc: '反转再反转，不到最后一页永远猜不到真相。悬疑迷的终极片单来了。',
    tag: '悬疑专题',
    date: '7月23日',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20fashionable%20couple%20walking%20in%20a%20trendy%20shopping%20district%2C%20vibrant%20city%20lights%2C%20modern%20romance%20vibe%2C%20stylish%20and%20colorful&width=800&height=500&seq=card-manga-04&orientation=landscape',
    title: '2025韩漫年度盘点：不可错过的韩国漫画精品',
    desc: '从恋爱到奇幻，韩国漫画产业正在以惊人的速度崛起，这些精品值得一读。',
    tag: '韩漫专题',
    date: '7月22日',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20manhua%20scene%20with%20a%20warrior%20meditating%20on%20a%20misty%20mountain%2C%20traditional%20Chinese%20aesthetics%2C%20elegant%20brushwork%2C%20serene%20and%20majestic%20atmosphere&width=800&height=500&seq=card-manga-05&orientation=landscape',
    title: '国漫崛起进行时：这些国产漫画质量不输日漫',
    desc: '从画风到剧情，国漫正在用实力证明自己。这份片单收好不谢。',
    tag: '国漫专题',
    date: '7月21日',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20whimsical%20and%20imaginative%20landscape%2C%20soft%20dreamy%20colors%2C%20adventure%20theme%2C%20wide%20panoramic%20composition&width=800&height=500&seq=card-manga-06&orientation=landscape',
    title: '异世界转生漫画大盘点：换个世界换个活法',
    desc: '从社畜到勇者只需要一辆卡车。异世界题材漫画的经典与创新都在这里。',
    tag: '奇幻专题',
    date: '7月20日',
  },
];

export const updatesData = [
  { id: 1, time: '10分钟前', title: '《绝世武魂》第1287话', desc: '天骄之战！主角以一敌百，突破极限展现全新境界', tag: '最新更新', type: 'update' },
  { id: 2, time: '25分钟前', title: '《剑来》第893话', desc: '剑气长城之上，陈平安与远古大妖展开终极对决', tag: '热门连载', type: 'update' },
  { id: 3, time: '1小时前', title: '《全职猎人》第401话', desc: '黑暗大陆篇持续推进，新的念能力体系逐步揭晓', tag: '日漫更新', type: 'update' },
  { id: 4, time: '2小时前', title: '平台公告', desc: '番茄漫画APP 5.0版本即将上线，全新阅读体验与社交功能', tag: '官方公告', type: 'announce' },
  { id: 5, time: '3小时前', title: '《偷偷藏不住》第356话', desc: '桑稚与段嘉许的感情线迎来重大转折，甜蜜浓度爆表', tag: '韩漫更新', type: 'update' },
  { id: 6, time: '5小时前', title: '新作速递', desc: '人气网文改编漫画《大奉打更人》正式上架番茄漫画平台', tag: '新作上架', type: 'new' },
  { id: 7, time: '8小时前', title: '《咒术回战》第272话', desc: '宿傩与五条悟的领域展开对决进入白热化阶段', tag: '爆款推荐', type: 'update' },
];

export const appData = {
  title: '随时随地，漫画随行',
  subtitle: '下载番茄漫画APP，解锁更畅快的阅读体验',
  features: [
    { icon: 'ri-download-2-line', text: '离线下载，无网也能看' },
    { icon: 'ri-moon-line', text: '夜间模式，护眼阅读' },
    { icon: 'ri-refresh-line', text: '云端同步，多设备无缝切换' },
    { icon: 'ri-notification-3-line', text: '更新提醒，第一时间追更' },
  ],
  qrPlaceholder: 'https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20QR%20code%20design%20with%20a%20cute%20manga%20character%20icon%20in%20the%20center%2C%20flat%20design%2C%20warm%20orange%20and%20white%20color%20scheme%2C%20modern%20app%20download%20style&width=300&height=300&seq=qrcode-manga-app&orientation=squarish',
};

export const contactData = {
  title: '联系我们',
  subtitle: '商务合作、版权洽谈、问题反馈，欢迎随时沟通',
  email: 'contact@fanqiemanga.com',
  wechat: '番茄漫画官方',
  weibo: '@番茄漫画',
  qq: '800123456',
};

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20manhua%20battle%20scene%20with%20warriors%20clashing%20in%20a%20grand%20arena%2C%20golden%20energy%20effects%2C%20cinematic%20wide%20shot%2C%20dramatic%20warm%20lighting%2C%20epic%20scale&width=1200&height=600&seq=carousel-manga-01&orientation=landscape',
    title: '绝世武魂',
    subtitle: '玄幻热血巅峰之作',
    desc: '少年身怀绝世武魂，从卑微中崛起，踏破九霄，问鼎苍穹。全平台累计阅读量突破50亿。',
    tag: '连载中·更新至1287话',
    href: '#index',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manhua%20scene%20with%20a%20boy%20and%20girl%20sharing%20earbuds%20on%20a%20sunny%20campus%20bench%2C%20cherry%20blossoms%20falling%2C%20warm%20golden%20hour%20light%2C%20sweet%20shojo%20atmosphere&width=1200&height=600&seq=carousel-manga-02&orientation=landscape',
    title: '偷偷藏不住',
    subtitle: '甜宠恋爱人气冠军',
    desc: '暗恋是一个人的兵荒马乱，也是两个人的双向奔赴。全网最甜校园恋爱漫画。',
    tag: '连载中·更新至356话',
    href: '#index',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20illustration%20with%20hunters%20facing%20a%20gigantic%20shadow%20creature%20in%20a%20ruined%20city%2C%20moody%20atmospheric%20lighting%2C%20epic%20scale%2C%20detailed%20character%20designs&width=1200&height=600&seq=carousel-manga-03&orientation=landscape',
    title: '全职猎人',
    subtitle: '富坚义博传奇经典',
    desc: '少年杰·富力士踏上猎人之路，在未知的世界中追寻父亲的足迹。连载二十年人气不衰的传奇作品。',
    tag: '连载中·更新至401话',
    href: '#index',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20beauty%20makeover%20scene%2C%20a%20girl%20transforming%20from%20plain%20to%20stunning%2C%20fashionable%20city%20backdrop%2C%20vibrant%20colors%2C%20trendy%20and%20glamorous&width=1200&height=600&seq=carousel-manga-04&orientation=landscape',
    title: '女神降临',
    subtitle: '韩漫逆袭经典完结',
    desc: '化妆改变命运，平凡女孩通过化妆术实现人生逆袭。267话完结，一口气看到结局的爽快体验。',
    tag: '已完结·共267话',
    href: '#index',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20style%20swordsman%20manhua%20scene%2C%20a%20lone%20warrior%20with%20a%20sword%20walking%20through%20a%20bamboo%20forest%20in%20moonlight%2C%20traditional%20aesthetic%2C%20poetic%20atmosphere%2C%20misty%20mountains&width=1200&height=600&seq=carousel-manga-05&orientation=landscape',
    title: '剑来',
    subtitle: '国漫仙侠里程碑',
    desc: '陈平安持剑走天下，一部融合儒释道哲学的仙侠史诗。画风与文笔双绝的口碑神作。',
    tag: '连载中·更新至893话',
    href: '#index',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Modern%20supernatural%20manga%20scene%20with%20sorcerers%20casting%20spells%20in%20a%20neon%20lit%20urban%20alley%2C%20dynamic%20action%20pose%2C%20vibrant%20curse%20energy%20visuals%2C%20stylish%20and%20intense&width=1200&height=600&seq=carousel-manga-06&orientation=landscape',
    title: '咒术回战',
    subtitle: '现象级日漫爆款',
    desc: '咒术师与诅咒之王之间的宿命对决，重新定义了现代热血漫画的天花板。',
    tag: '连载中·更新至272话',
    href: '#index',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '完全免费',
    desc: '所有漫画永久免费阅读，不设任何付费墙。畅享海量漫画无需花一分钱。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '每日同步更新300+话，热门连载发布后2小时内同步上架，追更快人一步。',
  },
  {
    id: 3,
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全平台支持超高清画质阅读，每一格分镜都纤毫毕现，沉浸式漫画体验。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '网页、iOS、Android三端阅读进度云端实时同步，换设备无缝衔接阅读。',
  },
  {
    id: 5,
    icon: 'ri-download-cloud-2-line',
    title: '离线下载',
    desc: '支持批量离线下载，地铁、飞机、旅途中无网络也能畅快追漫随行随看。',
  },
];

export const rankingData = [
  { rank: 1, title: '绝世武魂', type: '玄幻热血', hot: '9.6', trend: 'up', desc: '持续霸榜128天' },
  { rank: 2, title: '咒术回战', type: '日漫热血', hot: '9.5', trend: 'up', desc: '本周上升2位' },
  { rank: 3, title: '剑来', type: '仙侠国漫', hot: '9.7', trend: 'stable', desc: '口碑评分第一' },
  { rank: 4, title: '偷偷藏不住', type: '恋爱韩漫', hot: '9.4', trend: 'up', desc: '新晋人气王' },
  { rank: 5, title: '全职猎人', type: '冒险日漫', hot: '9.8', trend: 'stable', desc: '经典长青树' },
  { rank: 6, title: '女神降临', type: '恋爱韩漫', hot: '9.3', trend: 'down', desc: '完结热度不减' },
  { rank: 7, title: '一人之下', type: '国漫奇幻', hot: '9.5', trend: 'up', desc: '动画联动加持' },
];

export const footerLinks = {
  sections: [
    {
      title: '漫画分类',
      links: [
        { label: '热血冒险', href: '#index' },
        { label: '恋爱校园', href: '#index' },
        { label: '玄幻仙侠', href: '#index' },
        { label: '悬疑推理', href: '#index' },
        { label: '都市生活', href: '#index' },
      ],
    },
    {
      title: '快捷入口',
      links: [
        { label: '人气推荐', href: '#media' },
        { label: '排行榜', href: '#ranking' },
        { label: '最近更新', href: '#updates' },
        { label: '热门话题', href: '#topics' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: 'APP下载', href: '#app' },
        { label: '用户协议', href: '#faq' },
        { label: '隐私政策', href: '#faq' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ],
};